const zh = {
	accessThePrinter: '接入分端服务器',
	access: '接入',
	disconnect: '断开',
	domainName: '域名',
	accessedList: '已接入列表',
	operate: '操作',
	edit: '编辑',
	introduction: '简介',
	modifyInformation: '修改信息',
	sure: '确定',
	cancel: '取消',
	name: '名称',
	connected: '已接入',
	disconnected: '已断开',
	splitServerIinfo: '分端服务器信息',
};

export default zh;
